import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";
import crypto from "../../../assets/Cryptography.jpeg";
import malware from "../../../assets/malware.jpeg";
import mobileSec from "../../../assets/mobile-security.jpeg";
import appWebSec from "../../../assets/web-application-security";
import osSecurity from "../../../assets/os-security.jpg";
import penTesting from "../../../assets/pen-testing.jpg";
import introSec from "../../../assets/intro-sec.jpg";

const CyberSecurityPrograms = [
    {
        id: 1,
        image: introSec,
        heading: "Introduction to Cyber Security",
        introduction:
            "Learn the basics of cyber security, threats, and defense mechanisms.",
        buttonText: "LEARN MORE",
        route: "intro-to-cyber-security",
    },
    {
        id: 2,
        image: osSecurity,
        heading: "Network & OS Security",
        introduction:
            "Understand how to secure computer networks and operating systems.",
        buttonText: "LEARN MORE",
        route: "network-os-security",
    },
    {
        id: 3,
        image: crypto,
        heading: "Cryptography Basics",
        introduction:
            "Explore encryption, decryption, and cryptographic security methods.",
        buttonText: "LEARN MORE",
        route: "cryptography-basics",
    },
    {
        id: 4,
        image: penTesting,
        heading: "Ethical Hacking & Pen Testing",
        introduction:
            "Learn penetration testing, ethical hacking tools, and security audits.",
        buttonText: "LEARN MORE",
        route: "ethical-hacking-pen-testing",
    },
    {
        id: 5,
        image: appWebSec,
        heading: "Web Application Security",
        introduction:
            "Identify and fix vulnerabilities in websites and web applications.",
        buttonText: "LEARN MORE",
        route: "web-application-security",
    },
    {
        id: 6,
        image: malware,
        heading: "Malware & Forensics",
        introduction:
            "Analyze malware attacks and perform digital forensic investigations.",
        buttonText: "LEARN MORE",
        route: "malware-forensics",
    },
    {
        id: 7,
        image: mobileSec,
        heading: "Wireless & Mobile Security",
        introduction:
            "Secure wireless networks and protect mobile devices from cyber threats.",
        buttonText: "LEARN MORE",
        route: "wireless-mobile-security",
    },
];

const CyberSecurityProgramsCard = () => {
    return (
        <div className="flex justify-center space-x-0">
            <CourseProgramCards
                programs={CyberSecurityPrograms}
                basePath="/courses/cyber-security"
            />
        </div>
    );
};

export default CyberSecurityProgramsCard;
